import { render, staticRenderFns } from "./TeamEditModal.vue?vue&type=template&id=050f90aa&scoped=true"
import script from "./TeamEditModal.vue?vue&type=script&lang=js"
export * from "./TeamEditModal.vue?vue&type=script&lang=js"
import style0 from "./TeamEditModal.vue?vue&type=style&index=0&id=050f90aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050f90aa",
  null
  
)

export default component.exports